import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/reset.css";
import "@/assets/css/global.less";
import "@/assets/css/iconfont.css";
import VueI18n from "vue-i18n";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import filters from "./utils/filters.js";
import wl from "wl-vue-select";
import "wl-vue-select/lib/wl-vue-select.css";

import ElementLocale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en'
import formCreate from '@form-create/element-ui'
import watermark from './utils/watermark.js';
//import Cookies from "js-cookie";

const en_us = {
  ...require("./assets/languages/en_us.json"),
  ...enLocale
}
Vue.prototype.clearLocalData = function () {
    // 清除localStorage
    localStorage.clear()
    // 清除sessionStorage
    sessionStorage.clear()
    console.log('clear-->localStorage|sessionStorage');
    return false;
}

Vue.prototype.ucWatermark = function () {
    let localStorageObj = sessionStorage;
    let wm_count = parseInt(localStorageObj.getItem('wm_count'));
    if (!Number.isNaN(wm_count) && wm_count >= 20) {
        return
    }

    let url = window.location.href;
    if (url.indexOf("https") < 0 && url.indexOf("-dev") < 0 && url.indexOf("-stg") < 0 && url.indexOf('localhost') < 0) {
        url = url.replace("http:", "https:");
        window.location.replace(url);
    }
    let env = '';
    (url.indexOf('-dev') > 0 || url.indexOf('localhost') > 0) && (env = 'dev');
    url.indexOf('-stg') > 0 && (env = 'stg');
    url.indexOf('-pre') > 0 && (env = 'pre');
    console.log('thisPage_env==>', env)
    //if (env == 'dev' || env == 'stg' || env == 'pre') {
    let domain = window.location.host;
    let str2 = '';
    let uinfo = JSON.parse(localStorageObj.getItem('vuex'));
    if (uinfo == null) {
        console.log('clear0-->localStorage|sessionStorage');
        return this.clearLocalData();
    }

    let ttl = uinfo.userInfo.ttl;
    console.log('localStorage typeof (ttl)', typeof (ttl));
    if (typeof (ttl) == 'undefined') {
        console.log('clear2-->localStorage|sessionStorage');
        return this.clearLocalData();
    }
    let timeNowSec = Math.floor(Date.now() / 1000);
    if (timeNowSec >= ttl) {
        console.log('clear by ttl-->localStorage|sessionStorage');
        return this.clearLocalData();
    }

    let loginIP = uinfo.userInfo.loginIP;
    if (typeof (loginIP) == 'undefined') {
        loginIP = '';
    }

    let loginAccount = uinfo.userInfo.account;
    if (typeof (loginAccount) == 'undefined') {
        console.log('clear3-->localStorage|sessionStorage');
        return this.clearLocalData();
    }

    if (uinfo) {
        str2 = loginAccount + ' ' + loginIP;
    }
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    month = (month > 9) ? month : ("0" + month);
    day = (day < 10) ? ("0" + day) : day;
    let today = year + "-" + month + "-" + day;
    watermark.set(env.toUpperCase() + ' ' + domain, str2, today);
    //}
}

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

Vue.use(ElementUI)
Vue.use(VueI18n);
Vue.use(wl);
Vue.use(formCreate)

const locales = {
  en_us
};

const i18n = new VueI18n({
  locale: "en_us",
  messages: locales
});

ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.config.productionTip = false;
import { Popover } from "element-ui";
Vue.use(Popover);
window.vm = new Vue({
    router,
    store,
    i18n,
    mounted() {
        this.ucWatermark();
    },
    render: h => h(App)
}).$mount("#app");
